import { meditationService } from 'src/config/rootService';
import { MeditationProgressNode } from 'src/generated/webapp_gql';
import { GetMeditationsQuery } from '../documents/getMeditationsQuery.generated';

import { MeditationCategoryWithMeditations } from '../models/meditation';

export type MeditationNodeFragment = NonNullable<
    NonNullable<GetMeditationsQuery['meditations']>[number]
>;

export interface MeditationState {
    meditationCategories: MeditationCategoryWithMeditations[];
    meditationProgress: MeditationProgressNode[];
}

const defaultState: MeditationState = {
    meditationCategories: [],
    meditationProgress: [],
};

export const meditation = {
    state: defaultState,
    reducers: {
        addMeditations: (
            state: MeditationState,
            payload: MeditationCategoryWithMeditations[],
        ): MeditationState => {
            state.meditationCategories = payload;

            return state;
        },

        addMeditationProgress: (
            state: MeditationState,
            payload: MeditationProgressNode[],
        ): MeditationState => {
            state.meditationProgress = payload;

            return state;
        },
    },
    effects: dispatch => ({
        async fetchMeditations(): Promise<void> {
            meditationService.fetchMeditationCategories().then(dispatch.meditation.addMeditations);
            meditationService
                .fetchMeditationProgress()
                .then(dispatch.meditation.addMeditationProgress);
        },
        async startMeditation(startedMeditation: MeditationNodeFragment): Promise<void> {
            meditationService.startMeditation(startedMeditation.name);
        },
        async finishMeditation(finishedMeditation: MeditationNodeFragment): Promise<void> {
            meditationService.finishMeditation(finishedMeditation.name);
        },
    }),
};
